module.exports = __webpack_public_path__ + "img/schedule.497ccf80.svg";